export default function customImageLoader({ src, width, quality }) {
  // Send non relative urls directly to the source.
  if (src.startsWith('http')) {
    return src;
  }
  // Use NextJS image optimization API for relative urls.
  return `/front-page-images/_next/image?url=${src}&w=${width}&q=${quality || 75} `;
}
